// File: brightresolve-app/src/components/DisclaimerBanner.jsx
import React from 'react';

export default function DisclaimerBanner() {
  return (
    <div className="br-chat-disclaimer">
      BrightResolve is not a substitute for professional therapy or emergency support.
    </div>
  );
}
